import $ from 'jquery';
import formatCaption from './formatCaption';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    formatCaption(`[data-section-id="${e.detail.sectionId}"]`);
  });
};